module.exports = __webpack_public_path__ + "static/media/brochure.972176b6.pdf";